import {RouterLinks} from "./router-links";

export enum MenuHeaderLabels {
  MonEspacePersonnel = 'Mon espace personnel'
}

export enum MenuHeaderPaths {
  MonEspacePersonnel = '/' + RouterLinks.MyAccount,
}
